import { render } from "./ResumedData.vue?vue&type=template&id=fed4c7e2&scoped=true"
import script from "./ResumedData.vue?vue&type=script&lang=js"
export * from "./ResumedData.vue?vue&type=script&lang=js"

import "./ResumedData.vue?vue&type=style&index=0&id=fed4c7e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed4c7e2"]])

export default __exports__